const WaveBackground = () => {
  return (
    <>
      <style>{`
        .wave-background {
          position: absolute;
          top: -15%;
          left: 0;
          width: 100%;
          overflow: hidden;
          line-height: 0;
          z-index: 0;
        }

        .wave-svg {
          width: 100%;
          height: 8rem;
        }

        @media (min-width: 768px) {
          .wave-background {
            top: -13%;
          }

          .wave-svg {
            height: 12rem;
          }
        }

        @media (min-width: 1024px) {
          .wave-background {
            top: -15%;
          }

          .wave-svg {
            height: 12rem;
          }
        }
      `}</style>

      <div className="wave-background">
        <svg
          className="wave-svg"
          viewBox="0 0 1440 528"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M-132.961 231.604C-132.961 231.604 -547.429 477.761 -82.1851 513.906C816.144 609.284 826.88 184.39 1495.32 328.645C2715.11 321.43 1555.31 155.104 1555.31 155.104C857.721 227.093 380.539 280.104 -132.961 231.604Z"
            fill="#904CEE"
          />
          <path
            d="M1554.64 372.906C1554.64 372.906 2019.88 50.2485 1554.64 14.1039C656.309 -81.2749 645.573 343.619 -22.863 199.365C-1242.66 206.58 -82.8614 372.906 -82.8614 372.906C729.604 307.909 1372.45 111.435 1554.64 372.906Z"
            fill="#904CEE"
          />
          <path
            d="M-132.961 210.604C-132.961 210.604 -547.429 456.761 -82.1851 492.906C816.144 588.284 826.88 163.39 1495.32 307.645C2715.11 300.43 1555.31 134.104 1555.31 134.104C838.548 249.558 343.898 342.16 -132.961 210.604Z"
            fill="#904CEE"
          />
        </svg>
      </div>
    </>
  );
};

export default WaveBackground;
